<!-- Profile Sidebar -->
<div class="profile-sidebar">
    <div class="widget-profile pro-widget-content">
        <div class="profile-info-widget">
            <a href="javascript:void(0)" class="booking-doc-img border-r-12">
                <img class="border-less" [src]="app.getUserImage(hcp?.picture)" alt="User Image">
            </a>
            <div class="profile-det-info">
                <h3 class="blue-text">{{hcp?.name}}</h3>
                <div class="patient-details">
                    <h5><i class="fa fa-birthday-cake"></i> {{hcp?.birthDate | date :'MMM d, y'}}, {{hcp?.age}}
                        years</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="dashboard-widget">
        <nav class="dashboard-menu">
            <ul>
                <li routerLinkActive="active">
                    <a [routerLink]="'/' + app?.languageCode +'/doctor/appointment'">
                        <i class="fa fa-calendar-check-o"></i>
                        <span>{{ 'NavBar.Appointments' | translate }}</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a [routerLink]="'/' + app?.languageCode +'/doctor/available-timings'">
                        <i class="fa fa-clock-o"></i>
                        <span>{{ 'NavBar.availableTimings' | translate }}</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a [routerLink]="'/' + app?.languageCode +'/doctor/doctor-change-password'">
                        <i class="fa fa-lock"></i>
                        <span>{{ 'Patient.ChangePassword' | translate }}</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a [routerLink]="'/' + app?.languageCode +'/doctor/schedule-session'">
                        <i class="fa fa-user-md"></i>
                        <span>{{ 'medicalHis.ScheduleSession' | translate }}</span>
                    </a>
                </li>
                <li *ngIf="this.app.isPMSubscribed" routerLinkActive="active">
                    <a  [routerLink]="'/' + app?.languageCode +'/doctor/clinics'">
                        <i class="fa fa-hospital-o"></i>
                        <span>{{ 'medicalHis.ClinicManagement' | translate }}</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a [routerLink]="'/' + app?.languageCode +'/Tebgram/activity'">
                        <i class="fa fa-user"></i>
                        <span>{{ 'social.myCommAct' | translate }}</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a [routerLink]="'/' + app?.languageCode +'/Tebgram/profile'">
                        <i class="fa fa-bookmark"></i>
                        <span>{{ 'social.myCommProfile' | translate }}</span>
                    </a>
                </li>
                <li >
                    <a [routerLink]="'/' + app?.languageCode +'/inbox'">
                        <i class="fa fa-comments-o"></i>
                        <span>{{ 'message.inbox' | translate }}</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a [routerLink]="'/' + app?.languageCode +'/doctor/grant'">
                        <i class="fa fa-check-square"></i>
                        <span>{{ 'social.grant' | translate }}</span>
                    </a>
                </li>
                <li routerLinkActive="active">
                    <a [routerLink]="'/' + app?.languageCode +'/doctor/settings'">
                        <i class="fa fa-cog"></i>
                        <span>{{ 'Patient.ProfileSettings' | translate }}</span>
                    </a>
                </li>
                <li>
                    <a (click)="app?.mainLogOut()" class="hoverSideMenu" style="cursor: pointer;">
                        <i class="fa fa-sign-out"></i>
                        <span>{{ 'Patient.Logout' | translate }}</span>
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</div>